import { PersonRole } from './eums/personRole';
import { CertificationModel } from './certificationModel';
import moment from 'moment';

export interface UserInvitationModel {
  emailAddress: string;
  userRole: PersonRole;
  registrationValidity: Date;
  certifications: CertificationModel[];
}

export const emptyUserInvitationObj: UserInvitationModel = {
  emailAddress: '',
  userRole: PersonRole.Referee,
  registrationValidity: moment().add(1, 'year').toDate(),
  certifications: [],
};
